import { CircularProgress, Grid } from '@mui/material'
import React from 'react'
import styles from './../../../insights.module.css';
import docIcon from '../../../../../Assets/docIcon.png'
import downloadIcon from '../../../../../Assets/downloadIcon.png'
import { useDocumentCard } from './documentCard.hooks';

interface IDocumentCardProps {
    docLink: string | null | undefined;
    docName: string;
}

const DocumentCard = (props: IDocumentCardProps) => {
    const { docName, docLink } = props
    const { isDownloading, handleDownload } = useDocumentCard({docName, docLink});

    if(!docLink) {
        return null
    }

    return (
        <Grid item xl={2} lg={3} md={4} sm={6} xs={5} className={styles.linkBoxStyle}>
            <Grid container className={styles.docBoxContainer}>
                <Grid item className={styles.linkIconStyles}>
                    <img src={docIcon} alt="" />
                    <span className={styles.linkStyle}>{docName}</span>
                </Grid>
                <Grid item className={styles.openIconStyles}>
                    <button
                        type="button"
                        onClick={handleDownload}
                        disabled={isDownloading}
                        className={styles.openIconLink}
                    >
                        {isDownloading ? <CircularProgress size={20} /> : null}
                        <img src={downloadIcon} alt={`Download ${docName}`} />
                    </button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default DocumentCard